//
// Copyright (c) 2011-2023 by Curalate, Inc.
//

import React from 'react';
import styled, { css } from 'styled-components';

import { SmallTooltip } from '@components/molecules/tooltip/Tooltip';

interface ICopyrightedIconProps extends React.HTMLAttributes<HTMLDivElement> {
  size?: number;
}

/**
 * The Copyrighted icon atom is used to render a copyrighted icon with a specified size
 */
export const CopyrightedIcon = ({
  className,
  size = 22,
}: ICopyrightedIconProps) => {
  return (
    <CopyrightedSvg
      className={className}
      size={size}
      viewBox='0 0 22 22'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path d='M10.93 8.2c.7 0 1.4.28 1.89.84l.98-.98c-.77-.84-1.82-1.26-2.87-1.26-1.12 0-2.1.42-2.94 1.26-1.61 1.61-1.61 4.27 0 5.95.77.77 1.82 1.19 2.94 1.19s2.1-.42 2.94-1.26l-.98-.98c-1.05 1.05-2.8 1.05-3.78 0-1.05-1.12-1.05-2.87 0-3.99.42-.49 1.05-.77 1.82-.77Z' />
      <path d='M11 16.6c-3.08 0-5.6-2.52-5.6-5.6S7.92 5.4 11 5.4s5.6 2.52 5.6 5.6-2.52 5.6-5.6 5.6ZM11 4c-3.85 0-7 3.15-7 7s3.15 7 7 7 7-3.15 7-7-3.15-7-7-7Z' />
    </CopyrightedSvg>
  );
};

export const CopyrightedIconWithTooltip = ({
  className,
  size,
}: ICopyrightedIconProps) => {
  return (
    <SmallTooltip
      className={className}
      content={
        'This media received a copyright notice on Instagram. Only the thumbnail can be used or distributed on Bazaarvoice Vibe.'
      }
      isDisabled={false}
      target={<CopyrightedIcon className={className} size={size} />}
    />
  );
};

// drop-shadow is based on the size of the component since it can't take a percent
const CopyrightedSvg = styled.svg<{ size: number }>(
  ({ size, theme }) => css`
    filter: drop-shadow(${size * 0.045}px ${size * 0.045}px ${size * 0.14}) px;
    fill: ${theme.colors.white};
    height: ${size}px;
    width: ${size}px;
  `,
);
